import React from 'react';
import { ShieldCheck, Copy, Download } from 'lucide-react';
import { PrimaryButton, GhostButton } from './LoginControls';

const RecoveryCodesStep = ({ codes, email, saved, setSaved, onContinue }) => {
  const copyCodes = async () => { try { await navigator.clipboard.writeText(codes.join('\n')); } catch { /* ignore */ } };
  const download = () => {
    const blob = new Blob([`DerwentAI recovery codes for ${email}\n\n${codes.join('\n')}\n`], { type: 'text/plain' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'derwentai-recovery-codes.txt'; a.click();
  };
  return (
    <div className="space-y-4" data-testid="recovery-codes-panel">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-3 rounded-2xl bg-emerald-50 flex items-center justify-center">
          <ShieldCheck className="w-6 h-6 text-emerald-600" strokeWidth={2} />
        </div>
        <p className="text-slate-900 font-semibold text-[15px]">Save your recovery codes</p>
        <p className="text-slate-500 text-[13px] mt-1 leading-relaxed">Each code signs you in once if you lose your authenticator. Store them in your password manager — they will not be shown again.</p>
      </div>
      <div className="grid grid-cols-2 gap-1.5 rounded-xl border border-slate-200 bg-slate-50/80 p-3 font-mono text-[13px] text-slate-800">
        {codes.map((c) => <div key={c} className="text-center py-1.5 rounded-md bg-white border border-slate-100" data-testid="recovery-code">{c}</div>)}
      </div>
      <div className="flex gap-2">
        <GhostButton onClick={copyCodes} className="flex-1 inline-flex items-center justify-center gap-1.5" data-testid="recovery-codes-copy"><Copy className="w-3.5 h-3.5" /> Copy codes</GhostButton>
        <GhostButton onClick={download} className="flex-1 inline-flex items-center justify-center gap-1.5" data-testid="recovery-codes-download"><Download className="w-3.5 h-3.5" /> Download</GhostButton>
      </div>
      <label className="flex items-start gap-2.5 text-[13px] text-slate-700 cursor-pointer">
        <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} className="mt-0.5 w-4 h-4 rounded border-slate-300 accent-[#1F47D6]" data-testid="recovery-codes-saved-checkbox" />
        I have saved these codes somewhere safe
      </label>
      <PrimaryButton type="button" disabled={!saved} onClick={onContinue} data-testid="recovery-codes-continue">Continue to DerwentAI</PrimaryButton>
    </div>
  );
};

export default RecoveryCodesStep;
